export interface IPresetThemeResponse {
  Id?: number
  Name?: string
  Config?: {
    Label?: string
    Colors?: {
      HeaderBackground?: string
      FooterBackground?: string
      PrimaryColour?: string
      SecondaryColour?: string
      LinkText?: string
      NavText?: string
      PrimaryButtonText?: string
      SecondaryButtonText?: string
      Borders?: string
      PrimaryCardText?: string
      SecondaryCardText?: string
    }
    Fonts?: {
      HeadingFont?: string
      BaseFont?: string
    }
    IsDefault?: boolean
  }
}

export class PresetTheme {
  public id?: number
  public name?: string
  public config?: {
    label?: string
    colors?: {
      headerBackground?: string
      footerBackground?: string
      primaryColour?: string
      secondaryColour?: string
      linkText?: string
      navText?: string
      primaryButtonText?: string
      secondaryButtonText?: string
      borders?: string
      primaryCardText?: string
      secondaryCardText?: string
    }
    fonts?: {
      headingFont?: string
      baseFont?: string
    }
    isDefault?: boolean
  }

  constructor(response: Partial<IPresetThemeResponse>) {
    this.id = response.Id
    this.name = response.Name
    this.config = {
      label: response.Config?.Label,
      colors: {
        headerBackground: response.Config?.Colors?.HeaderBackground,
        footerBackground: response.Config?.Colors?.FooterBackground,
        primaryColour: response.Config?.Colors?.PrimaryColour,
        secondaryColour: response.Config?.Colors?.SecondaryColour,
        linkText: response.Config?.Colors?.LinkText,
        navText: response.Config?.Colors?.NavText,
        primaryButtonText: response.Config?.Colors?.PrimaryButtonText,
        secondaryButtonText: response.Config?.Colors?.SecondaryButtonText,
        borders: response.Config?.Colors?.Borders,
        primaryCardText: response.Config?.Colors?.PrimaryCardText,
        secondaryCardText: response.Config?.Colors?.SecondaryCardText,
      },
      fonts: {
        headingFont: response.Config?.Fonts?.HeadingFont ?? "Comfortaa",
        baseFont: response.Config?.Fonts?.BaseFont ?? "Montserrat",
      },
      isDefault: response.Config?.IsDefault ?? false,
    }
  }

  public static fromResponse(response: IPresetThemeResponse) {
    return new PresetTheme(response)
  }
}
